import { Component, Input } from '@angular/core';

export interface UserReview {
  name: string;
  age: number;
  message: string;
  avatarUrl: string;
  title?: string;
  logoUrl?: string;

  rate?: number;
}

@Component({
  selector: 'app-user-review',
  imports: [],
  templateUrl: './user-review.component.html',
  styleUrl: './user-review.component.scss',
})
export class UserReviewComponent {
  @Input() data: UserReview;
}
